import React from 'react';
import PropTypes from 'prop-types';

import { animation } from '../../styles/constants';

// BoxShadow, TransformStyle and Translate3d are attempts at solving
// choppy svgs in Safari. Translate3d and BoxShadow are to enable hardware
// acceleration and transformStyle is from SO
// https://makandracards.com/makandra/31497-fixing-jerky-css3-animations
// https://stackoverflow.com/questions/11413758/choppy-svg-rendering-during-rotation-in-mobile-safari
const FooterCircles = ({ isInView, width, height, bottom, left }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    href="http://www.w3.org/1999/xlink"
    xlinkHref="http://www.w3.org/1999/xlink"
    style={{
      willChange: 'transform',
      position: 'absolute',
      transitionProperty: 'transform',
      transitionDuration: `${animation.introCircle}ms`,
      transitionTimingFunction: 'ease-in-out',
      transform: `translateZ(0.1px) translateY(${
        isInView ? 0 : `${height / 6}px`
      }) rotate(${(isInView ? 0 : 1 * 110) + 30}deg)`,
      opacity: bottom && left && width && height ? 1 : 0,
      width: `${width}px`,
      height: `${height}px`,
      bottom,
      left
    }}
    viewBox="0 0 2917 1583"
  >
    <g>
      <path
        d="M1458.5,365.192101 C1537.30836,488.239594 1583,634.53387 1583,791.5 C1583,948.46613 1537.30836,1094.76041 1458.5,1217.8079 C1379.6916,1094.76028 1334,948.466063 1334,791.5 C1334,634.533937 1379.6916,488.23972 1458.4999,365.19226 Z"
        fill="#0097FF"
      />
      <path
        d="M1458.5,1217.8079 C1379.6916,1094.76028 1334,948.466063 1334,791.5 C1334,634.533937 1379.6916,488.23972 1458.4999,365.19226 L1458.5,365.192101 C1317.83576,145.565883 1071.66725,1.8189894e-12 791.5,1.8189894e-12 C354.366621,1.8189894e-12 1.8189894e-12,354.366621 1.8189894e-12,791.5 C1.8189894e-12,1228.63338 354.366621,1583 791.5,1583 C1071.66725,1583 1317.83576,1437.43412 1458.5,1217.8079 Z"
        fill="#0054A4"
      />
      <path
        d="M2917,1217.8079 C2838.1916,1094.76028 2792.5,948.466063 2792.5,791.5 C2792.5,634.533937 2838.1916,488.23972 2916.9999,365.19226 L2917,365.192101 C2776.33576,145.565883 2530.16725,1.59161573e-12 2250,1.59161573e-12 C1812.86662,1.59161573e-12 1458.5,354.366621 1458.5,791.5 C1458.5,1228.63338 1812.86662,1583 2250,1583 C2530.16725,1583 2776.33576,1437.43412 2917,1217.8079 Z"
        fill="#06C2FC"
        transform="translate(2187.750000, 791.500000) scale(-1, 1) translate(-2187.750000, -791.500000) "
      />
    </g>
  </svg>
);

FooterCircles.propTypes = {
  color: PropTypes.string,
  isInView: PropTypes.bool.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default FooterCircles;
